'use strict';

module.exports = ['$scope', '$rootScope', '$timeout', 'config', 'OrderRequestSvc', 'PermissionSvc', 'MaterialSvc', function ($scope, $rootScope, $timeout, config, OrderRequestSvc, PermissionSvc, MaterialSvc) {
    // ------------------
    // scope functions
    // ------------------

    // ------------------
    // Watches
    // ------------------

    // ------------------
    // Helper functions
    // ------------------

    // ------------------
    // Fetch Data
    // ------------------
    OrderRequestSvc.get(config.order_id, $scope.$root.plant).success(function (order) {
        $scope.order = order;
    });

    PermissionSvc.getPlantPermissions($scope.plant).then(function (permissionsObject) {
        $scope.permissions = permissionsObject.permissions;
    });

    MaterialSvc.list($rootScope.plant).success(function (data) {
        $scope.output_materials = data.filter(function (item) {
            return item.is_output_material;
        });
    });

    // ------------------
    // Initialization
    // ------------------
    $scope.plant_object = {
        id: $rootScope.plant,
        name: PermissionSvc.permissionCache_by_id[$rootScope.plant].plant_name
    };

    $scope.canEdit = false;
}];